// extracted by mini-css-extract-plugin
export default {"loaderContainer":"AnimatedWasteLoader_loaderContainer__meUSH","iconContainer":"AnimatedWasteLoader_iconContainer__UT66F","fullPage":"AnimatedWasteLoader_fullPage__zB479"};